var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1794 10.8905L12.0001 0L4.82085 10.8905C3.97729 12.1697 3.49876 13.6505 3.43583 15.1765C3.37291 16.7026 3.72792 18.217 4.46335 19.56C5.19879 20.9029 6.28733 22.0244 7.61396 22.8059C8.94059 23.5874 10.456 24 12.0001 24C13.5443 24 15.0597 23.5874 16.3863 22.8059C17.7129 22.0244 18.8015 20.9029 19.5369 19.56C20.2724 18.217 20.6274 16.7026 20.5644 15.1765C20.5015 13.6505 20.023 12.1697 19.1794 10.8905V10.8905Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85693 15.4285C6.85693 16.1038 6.94562 16.7726 7.11792 17.3966C7.29022 18.0205 7.54277 18.5875 7.86114 19.065C8.17951 19.5426 8.55747 19.9214 8.97345 20.1798C9.38942 20.4383 9.83526 20.5713 10.2855 20.5713",
    stroke: "#747B8B",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropIcon);
export default __webpack_public_path__ + "static/media/drop-icon.a4bdbfba.svg";
export { ForwardRef as ReactComponent };